import { render, staticRenderFns } from "./BriefcaseDeleteModal.vue?vue&type=template&id=4751f643&scoped=true"
import script from "./BriefcaseDeleteModal.vue?vue&type=script&lang=js"
export * from "./BriefcaseDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./BriefcaseDeleteModal.vue?vue&type=style&index=0&id=4751f643&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4751f643",
  null
  
)

export default component.exports